import { render } from "./ReferralBranchHistory.vue?vue&type=template&id=7d085683"
import script from "./ReferralBranchHistory.ts?vue&type=script&lang=js&external"
export * from "./ReferralBranchHistory.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__